export default "__VITE_ASSET__BVuz1B48__"